import { render, staticRenderFns } from "./grantPermissions.vue?vue&type=template&id=64cf18b0&scoped=true&"
import script from "./grantPermissions.vue?vue&type=script&lang=ts&"
export * from "./grantPermissions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf18b0",
  null
  
)

export default component.exports